module.exports = __webpack_public_path__ + "static/media/8.6ba6c906.png";